<template>
	<div :class="classes">
		<input type="submit" v-bind="data" />
	</div>
</template>

<script>
export default {
	name: 'submit-button',
	props: {
		label: {
			type: String,
			default: 'Submit'
		},
		invalid: {
			type: Boolean,
			default: false
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		classes() {
			return ['submit', { 'submit--loading': this.loading }]
		},
		data() {
			return {
				disabled: this.invalid || this.loading,
				loading: this.loading,
				value: this.label
			}
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/components';
@import '~scss/mq';

.submit {
	position: relative;
	display: inline-block;

	&,
	> input {
		width: 100%;
	}

	> input {
		@include button--large;
		&:focus:not(disabled) {
			@extend %focus;
		}
	}

	&--loading {
		> input {
			color: transparent;
		}
		&::after {
			@include spinner--centered(1.75rem, $white);
			content: '';
			position: absolute;
			top: 50%;
			left: 50%;
		}
	}

	@include mq(md) {
		&,
		> input {
			width: auto;
		}
	}
}
</style>
